module.exports = __webpack_public_path__ + "img/knowledge_base_primary.d63b1295.svg";